import FormGroup from '@/core/components/FormGroup'
import { Input } from '@/components/ui'
import { ContinuousTopupQuestConfigDto } from '@/common/models/gamification'

import { CardNetworkCheckboxes } from './CardNetworkCheckboxes'
import { TokenPoolSelect } from './TokenPoolSelect'

interface ContinuousTopupConfigFieldsProps {
  value: ContinuousTopupQuestConfigDto
  onChange: (next: ContinuousTopupQuestConfigDto) => void
  editionId: string
}

/**
 * Editor for a CONTINUOUS_TOPUP quest's config: a points-per-unit rate (may be fractional) and an
 * optional card-network filter. There is no completion threshold — the quest never completes and
 * credits `floor(depositedAmount × pointsPerUnit)` points on every qualifying top-up.
 */
export const ContinuousTopupConfigFields = ({
  value,
  onChange,
  editionId,
}: ContinuousTopupConfigFieldsProps) => {
  const pointsPerUnitError =
    value.pointsPerUnit === undefined || value.pointsPerUnit <= 0

  return (
    <div className="space-y-6">
      <FormGroup
        label="Points per unit"
        error={
          pointsPerUnitError
            ? 'Required and must be greater than 0'
            : undefined
        }
      >
        <div>
          <Input
            type="number"
            step="0.0001"
            min="0"
            placeholder="e.g. 10 (points per 1 unit of default currency)"
            isInvalid={pointsPerUnitError}
            value={value.pointsPerUnit ?? ''}
            onChange={(e) =>
              onChange({
                ...value,
                pointsPerUnit:
                  e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
          />
          <span className="mt-1 block text-xs text-monochrome-2">
            Points earned per 1 unit of the festival's default currency. Each
            top-up credits floor(amount × rate). Decimals allowed.
          </span>
        </div>
      </FormGroup>

      <CardNetworkCheckboxes
        value={value.cardNetworks}
        onChange={(cardNetworks) => onChange({ ...value, cardNetworks })}
      />

      <TokenPoolSelect
        editionId={editionId}
        value={value.availableTokenPoolId}
        onChange={(availableTokenPoolId) =>
          onChange({ ...value, availableTokenPoolId })
        }
      />
    </div>
  )
}
